import { consolidationCartonIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const cartonOperationIdSchema = z
  .string()
  .max(64)
  .pipe(consolidationCartonIdFormat.schema)
  .refine((id) => {
    try {
      const value = consolidationCartonIdFormat.read(id);
      return value > 0n && value <= 9_223_372_036_854_775_807n;
    } catch {
      return false;
    }
  }, "Invalid carton ID")
  .transform((id) =>
    consolidationCartonIdFormat.write(consolidationCartonIdFormat.read(id)),
  );
